export function getLimitedEditionRoomPreviewSelection(formState) {
  const sizeSelection = formState?.limited_edition_size;
  const hasSizeSelection = Boolean(sizeSelection?.size && sizeSelection?.size_data);
  const museumLabel = formState?.limited_edition_museum_label;

  return {
    selectedSizeKey: hasSizeSelection ? sizeSelection.size : null,
    selectedSizeData: hasSizeSelection ? sizeSelection.size_data : null,
    selectedFrameKey: hasSizeSelection ? formState.limited_edition_frame ?? null : null,
    selectedMuseumLabelKey: hasSizeSelection && museumLabel !== 'none' ? museumLabel ?? null : null,
  };
}
